import { combineReducers } from "redux";
import common from "../reducers/common";
import user from "../reducers/user";
import auth from "./auth";
import movement from "./movement";
import payment from "./payment";
import deposit from "./deposit";
import general from "./general"
import withdraw from "./withdraw"
import ipo from "./ipo";

export const rootReducers = combineReducers({
    common,
    user,
    auth,
    movement,
    payment,
    deposit,
    general,
    withdraw,
    ipo
});
